module.exports = __webpack_public_path__ + "static/img/IllustrationOfMultimodalTransportCollaboration.481da62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-v2/IllustrationOfMultimodalTransportCollaboration.png
// module id = qeB7
// module chunks = 44